import "./main.css"
function Main(){
    return(
        <>
       <div className="maintenance">
  <h4>Maintenance</h4>
  <h5>Reset Your Username or Password</h5>

  <p>
    Enter your email address and a reset link will be sent to you.
    Let’s get you back to your account.
  </p>

  <form>
    <div className="mb-3">
      <label htmlFor="exampleInputEmail1" className="form-label">
        Email address
      </label>
      <input
        type="email"
        className="form-control"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
      />
      <div id="emailHelp" className="form-text">
        We’ll never share your email with anyone else.
      </div>
    </div>
  </form>

  <div className="social-icons mt-4 text-center">
    <i className="fa-brands fa-facebook mx-2"></i>
    <i className="fa-brands fa-twitter mx-2"></i>
    <i className="fa-brands fa-github mx-2"></i>
  </div>

  <p className="text-center mt-3">
    <a href="#forgot-password">Forgot your password?</a>
  </p>
</div>

        </>
    )
}
export default Main